// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getSystemConfigListReducer } from './getSystemConfigList';
import { reducer as submitSystemConfigReducer } from './submitSystemConfig';
import { reducer as deleteSystemConfigReducer } from './deleteSystemConfig';
import { reducer as systemConfigModalChangeReducer } from './systemConfigModalChange';
import { reducer as chooseCurrentSystemConfigReducer } from './chooseCurrentSystemConfig';
import { reducer as getSystemConfigTypeListReducer } from './getSystemConfigTypeList';
import { reducer as submitSystemConfigTypeReducer } from './submitSystemConfigType';
import { reducer as deleteSystemConfigTypeReducer } from './deleteSystemConfigType';
import { reducer as systemConfigTypeModalChangeReducer } from './systemConfigTypeModalChange';
import { reducer as chooseCurrentSystemConfigTypeReducer } from './chooseCurrentSystemConfigType';
import { reducer as getAllConfigTypeReducer } from './getAllConfigType';
import { reducer as getAllSystemConfigReducer } from './getAllSystemConfig';
import { reducer as getDictionariesListReducer } from './getDictionariesList';
import { reducer as getDictNameListReducer } from './getDictNameList';

const reducers = [
  getSystemConfigTypeListReducer,
  submitSystemConfigTypeReducer,
  deleteSystemConfigTypeReducer,
  systemConfigTypeModalChangeReducer,
  chooseCurrentSystemConfigTypeReducer,
  getSystemConfigListReducer,
  submitSystemConfigReducer,
  deleteSystemConfigReducer,
  systemConfigModalChangeReducer,
  chooseCurrentSystemConfigReducer,
  getAllConfigTypeReducer,
  getAllSystemConfigReducer,
  getDictionariesListReducer,
  getDictNameListReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/reducer.js